// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"0e870b7b","851":"bd4347e9"}[chunkId] + ".chunk.js";
};